"use strict";
/* eslint compat/compat:"off", no-bitwise:"off" */
Object.defineProperty(exports, "__esModule", { value: true });
exports.timeFormat = exports.zeroPad = exports.now = void 0;
exports.now = typeof performance !== 'undefined' && performance.now ? function () { return performance.now(); } : Date.now;
function zeroPad(n, min) {
    var val = n < 10 ? "0".concat(n) : n;
    if (min > 1 && n < 100) {
        val = "0".concat(val);
    }
    return val;
}
exports.zeroPad = zeroPad;
function timeFormat(ts) {
    var sec = ts / 1000;
    return "".concat(zeroPad((sec / 60) % 24 | 0), ":").concat(zeroPad(sec % 60 | 0), ".").concat(zeroPad(ts % 1000 | 0, 2));
}
exports.timeFormat = timeFormat;
//# sourceMappingURL=utils.js.map